export default __webpack_public_path__ + "static/media/ic_coins.e74618af.png";